import React from 'react';
import last from 'lodash/last';
import split from 'lodash/split';

import { UUID, TableViewType } from '../../../../../types';

import { IndexTableCell } from '../IndexTableCell';
import { PureButtonHelper } from '../../../../../helpers/buttons/PureButtonHelper';

import { copyToClipboard } from '../../../../../utils/copyToClipboard';

interface IndexTableCellUuidProps {
  uuid: UUID;
  viewType?: TableViewType;
}

function IndexTableCellUuid({ uuid, viewType }: IndexTableCellUuidProps) {
  return (
    <IndexTableCell withSpan viewType={viewType}>
      <PureButtonHelper
        text={last(split(uuid, '-'))}
        onClick={() => copyToClipboard(uuid)}
      />
    </IndexTableCell>
  );
}

export default IndexTableCellUuid;
